import React from 'react';
import {
  ContextMenu,
  ContextMenuItem,
  HeaderLink,
  ImageCircle,
  Layout,
  LayoutItem,
  CardHeader,
  SectionHeader,
  window,
} from '@axiom/ui';
import { PossibleImageSizes } from '@axiom/const';
import { Link } from 'react-router';
import type { FullCandidateAccount, Taxonomy } from '@axiom/validation';

import { CandidateUtil } from '../../utils/candidate-util';
import { LinkUtil } from '../../utils/link-util';
import { EnvUtil } from '../../utils/env-util';

export type MyBenchItemCardHeaderProps = {
  candidate: FullCandidateAccount;
  taxonomy: Taxonomy;
  isEnvoyUser?: boolean;
  onClickHide: () => void;
  onClickEditHighlights: () => void;
};

export const MyBenchCardHeader = ({
  candidate,
  taxonomy,
  isEnvoyUser,
  onClickHide,
  onClickEditHighlights,
}: MyBenchItemCardHeaderProps) => {
  return (
    <CardHeader>
      <Layout position="middle">
        <LayoutItem rightGutter="16px">
          <div>
            <ImageCircle
              name="PROFILE_IMAGE"
              src={CandidateUtil.getProfileImageUri(
                candidate,
                PossibleImageSizes.W_56
              )}
              size="small"
              imageName={candidate.calculatedDisplayName}
            />
          </div>
        </LayoutItem>
        <LayoutItem fluid>
          <HeaderLink>
            <Link
              data-test="NAME_LINK"
              to={LinkUtil.getShareUrl(candidate, taxonomy)}
            >
              <SectionHeader name="CANDIDATE_NAME">
                {candidate.calculatedDisplayName}
              </SectionHeader>
            </Link>
          </HeaderLink>
        </LayoutItem>
        {isEnvoyUser ? (
          <LayoutItem position="right">
            <ContextMenu name="CONTEXT_MENU" direction="left">
              {candidate.isHiddenExternal ? null : (
                <ContextMenuItem
                  name="HIDE_TALENT"
                  onClick={() => {
                    onClickHide();
                  }}
                >
                  Hide From Bench
                </ContextMenuItem>
              )}
              <ContextMenuItem
                name="EDIT_HIGHLIGHTS"
                onClick={() => {
                  onClickEditHighlights();
                }}
              >
                Edit Bench Highlights
              </ContextMenuItem>
              <ContextMenuItem
                name="VIEW_TALENT_PROFILE"
                onClick={() => {
                  window.open(
                    `${EnvUtil.envoyUrl}/talent-detail/${candidate.id}`,
                    '_blank'
                  );
                }}
              >
                View Talent Profile
              </ContextMenuItem>
            </ContextMenu>
          </LayoutItem>
        ) : null}
      </Layout>
    </CardHeader>
  );
};
